<!--
 * @Author: your name
 * @Date: 2021-04-09 16:19:42
 * @LastEditTime: 2021-04-26 11:48:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/blogger/bzList/list.vue
-->
<template>
  <div>
    <!-- 搜索条件 -->
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input
          style="width: 270px"
          v-model="formInline.bloggerName"
          clearable
          placeholder="博主名称"
          @keyup.enter.native="onSubmit"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          style="width: 270px"
          v-model="formInline.mediaAccountName"
          clearable
          placeholder="账号名称/ID/链接"
          @keyup.enter.native="onSubmit"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button plain @click="resetClick">重 置</el-button>
        <el-button type="primary" @click="onSubmit">搜 索</el-button>
      </el-form-item>
    </el-form>
    <div style="font-size: 15px">
      <span>博主总数：{{total}}条</span>
      <span style="padding: 0 30px">总粉丝数：{{allTotalFansNum}}</span>
      <!-- <span>总互动量：{{allTotalInteractNum}}</span> -->
    </div>
    <!-- 列表 -->
    <div style="padding:20px 0;" v-loading="loading">
      <el-table
        :data="tableData"
        ref="product"
        row-key="mediaId"
        :row-class-name="rowClassNameFun"
        :header-row-class-name="headerRowClassName"
        :highlight-current-row="true"
        size="mini"
        style="width: 100%"
        @select="selectFun"
        @select-all="selectAllFun"
        :cell-style="cellStyle"
        :header-cell-style="{ background: '#fafafa',border:'0px',}"
        :tree-props="{ children: 'mediaAccountList', hasChildren: 'hasChildren' }"
      >
        <el-table-column v-if="permissions.blogger_Show" align="center" type="selection" width="55"></el-table-column>
        <el-table-column prop="date" width="200" label="博主名称" class="AAAAAAAA">
          <template slot-scope="scope">
            <div v-if="scope.row.mediaAccountList">
              <div v-if="scope.row.mediaAccountList.length<=0" style="width:23px;height:20px;"></div>
            </div>
            <div class="account-wrap">
              <div class="avatar-out">
                <div class="avatar-in">
                  <div class="img-wrap" v-if="scope.row.avatar">
                    <!--有头像-->
                    <img v-if="scope.row.avatar.indexOf('/qr/code') !== -1" :src="scope.row.avatar" onerror="javascript:this.src='/img/media/wechat_default.png';" class="avatar is-code">
                    <img v-else :src="scope.row.avatar" onerror="javascript:this.src='/img/media/weibo_default.png';" class="avatar">
                  </div>
                  <div class="img-wrap" v-else>
                    <img src="/img/media/weibo_default.png" class="avatar">
                  </div>
                </div>
              </div>
              <div class="info-wrap">
                <el-tooltip :content="scope.row.name" placement="bottom" effect="light">
                  <div class="nickname"><span>{{ scope.row.name }}</span></div>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="140" align="center" prop="mediaTypeList" label="平台">
          <template slot-scope="scope">
            <div class="disbox_flx">
              <div style="width:30px;height:30px;text-align:center;line-height:30px;" v-for="(item,index) in scope.row.mediaTypeList" :key="index">
                <img v-if="item == 2" style="width:100%;height:100%;" src="@/assets/img/wb.png" alt="">
                <img v-else-if="item == 3" style="width:100%;height:100%;" src="@/assets/img/xhs.png" alt="">
                <img v-else-if="item == 5" style="width:100%;height:100%;" src="@/assets/img/bz.png" alt="">
                <img v-else-if="item == 6" style="width:100%;height:100%;" src="@/assets/img/ks.png" alt="">
                <img v-else-if="item == 4" style="width:85%;height:85%;margin-top:2px;border-radius:8px;" src="@/assets/img/dy.png" alt="">
                <img v-else-if="item == 1" style="width:85%;height:85%;margin-top:2px;border-radius:8px;" src="@/assets/img/wx.png" alt="">
                <img v-else-if="item == 7" style="width:85%;height:85%;margin-top:2px;border-radius:8px;" src="@/assets/img/tb.png" alt="">
              </div>
              <div v-if="scope.row.mediaType" style="width:30px;height:30px;text-align:center;line-height:30px;">
                <img v-if="scope.row.mediaType == 2" style="width:100%;height:100%;" src="@/assets/img/wb.png" alt="">
                <img v-else-if="scope.row.mediaType == 3" style="width:100%;height:100%;" src="@/assets/img/xhs.png" alt="">
                <img v-else-if="scope.row.mediaType == 5" style="width:100%;height:100%;" src="@/assets/img/bz.png" alt="">
                <img v-else-if="scope.row.mediaType == 6" style="width:100%;height:100%;" src="@/assets/img/ks.png" alt="">
                <img v-else-if="scope.row.mediaType == 4" style="width:85%;height:85%;border-radius:8px;" src="@/assets/img/dy.png" alt="">
                <img v-else-if="scope.row.mediaType == 1" style="width:85%;height:85%;border-radius:8px;" src="@/assets/img/wx.png" alt="">
                <img v-else-if="scope.row.mediaType == 7" style="width:85%;height:85%;border-radius:8px;" src="@/assets/img/tb.png" alt="">
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="100" align="center" prop="fansNum" label="总粉丝数">
          <template slot-scope="scope">
            <div>
              {{scope.row.totalFansNum}}
              {{scope.row.fansNum}}
            </div>
          </template>
        </el-table-column>
        <el-table-column  min-width="140" prop="interactNum" align="center" label="总互动量">
          <template slot-scope="scope">
            <div>{{scope.row.interactNum}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="categoryNameList" label="分类" width="200">
          <template slot-scope="scope">
            <div class="category_disp">
              <span class="category-item" v-for="(cate, index) in scope.row.categoryNameList || []" :key="index" v-show="index < 4">
                {{ cate }}
              </span>
              <div class="more-price" v-if="scope.row.categoryNameList && scope.row.categoryNameList.length>4" @click="classificationDetails(scope.row.categoryNameList,1)">
                <i class="iconfont icon-doubleArrowDown"></i>查看详情
              </div>
              <span class="category-item" v-for="(cate, index) in scope.row.categoryList || []" :key="index" v-show="index < 4">{{ cate.categoryName }}</span>
              <div class="more-price" v-if="scope.row.categoryList && scope.row.categoryList.length>4" @click="classificationDetails(scope.row.categoryList,2)">
                <i class="iconfont icon-doubleArrowDown"></i>查看详情
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" align="center" label="审批状态">
          <template slot-scope="scope">
            <div>{{scope.row.status == 0?"审批中":scope.row.status == 1?"审批通过":"审批不通过"}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="name" min-width="230" label="价格信息">
          <template slot-scope="scope">
            <div class="media-price-wrap" v-if="scope.row.mediaPriceList">
              <ul v-if="scope.row.mediaPriceList !== null && scope.row.mediaPriceList.length !== 0">
                <li style="font-size:14px;" v-for="(priceItem, index) in scope.row.mediaPriceList.filter(v => !checkNull(v.publishPrice))" :key="scope.row.id + '-' + index" :data-key="scope.row.id + '-' + index" v-show="index < 4">
                  {{ priceItem.publishType }}：{{ readableNum(priceItem.publishPrice) }}</li>
              </ul>
              <span v-else>--</span>
              <span v-if="scope.row.mediaPriceList && scope.row.mediaPriceList.filter(v => !checkNull(v.publishPrice)).length > 4" class="more-price" @click="onShowMorePrice(scope.row.mediaPriceList)">
                <i class="iconfont icon-doubleArrowDown"></i>查看详情
              </span>
            </div>
          </template>

        </el-table-column>
        <el-table-column align="center" prop="name" label="合作品牌" min-width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.updateUserId">
              <el-tooltip v-if="!checkNull(scope.row.cooperationBrand)" :content="scope.row.cooperationBrand" placement="bottom" effect="light" :popper-class="'overflow-content-tooltip'">
                <p class="overflow-content-wrap">{{ scope.row.cooperationBrand }}</p>
              </el-tooltip>
              <span v-else>--</span>
            </div>
            <div v-else>
              <el-tooltip v-if="!checkNull(scope.row.brandSide)" :content="scope.row.brandSide" placement="bottom" effect="light" :popper-class="'overflow-content-tooltip'">
                <p class="overflow-content-wrap">{{ scope.row.brandSide }}</p>
              </el-tooltip>
              <span v-else>--</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" width="150" prop="name" label="商务对接人">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.businessInfoList" :key="index">
              {{item.name}}
            </div>
          </template>
        </el-table-column>
        <el-table-column :fixed="tableFixed?'right':''" align="center" prop="name" label="操作">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 0">
              <el-button v-if="scope.row.updateUserId&&permissions.bloggerEdit" type="text" @click="editClick(scope.row.id)">编辑</el-button>
              <el-button v-if="!scope.row.updateUserId&&permissions.mediaEdit"  type="text" @click="toEdit(scope.row.mediaType, scope.row.mediaId)">编辑</el-button>
              <el-button v-if="scope.row.updateUserId" size="small" type="text" @click="approvalDeatilClick(scope.row.id,scope.row.parentId,1)">审批详情</el-button>
            </div>
            <div v-if="scope.row.status == 1">
              <el-button v-if="scope.row.updateUserId&&permissions.bloggerEdit" type="text" @click="editClick(scope.row.id)">编辑</el-button>
              <el-button v-if="!scope.row.updateUserId&&permissions.mediaEdit" type="text" @click="toEdit(scope.row.mediaType, scope.row.mediaId)">编辑</el-button>
            </div>
            <div v-if="scope.row.status == 2">
              <el-button v-if="scope.row.updateUserId&&permissions.bloggerEdit" type="text" size="small" @click='goUrl(scope.row.id)'>重新提交</el-button>
              <el-button v-if="scope.row.updateUserId" type="text" size="small" @click='approvalDeatilClick(scope.row.notPassReason,scope.row.parentId,2)'>原因</el-button>           
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="text-align:right;padding-bottom:20px;">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNum"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="formInline.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 订单名称 -->
    <el-dialog :visible.sync="dialogVisible" width="20%">
      <div style="padding-bottom:10px;font-size:15px;">请输入订单名称：</div>
      <el-input placeholder="请输入订单名称" v-model="OrderName" clearable  maxlength="25" show-word-limit></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 价格信息 -->
    <el-dialog title="价格列表" :visible.sync="priceModal" width="600px" class="yhg-dialog">
      <template>
        <el-table :data="priceModalTable" border>
          <el-table-column prop="publishType" label="发布形式" align="center">
            <template slot-scope="scope">
              {{ checkNull(scope.row.publishType) ? '--' : scope.row.publishType }}
            </template>
          </el-table-column>
          <el-table-column prop="publishPrice" label="刊例价" align="center">
            <template slot-scope="scope">
              {{ checkNull(scope.row.publishPrice) ? '--' :readableNum(scope.row.publishPrice) }}
            </template>
          </el-table-column>
          <el-table-column prop="discountPrice" label="折后价" align="center">
            <template slot-scope="scope">
              {{ checkNull(scope.row.discountPrice) ? '--' : readableNum(scope.row.discountPrice) }}
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-dialog>
    <!-- 分类详情 -->
    <el-dialog
      title="分类详情"
      :visible.sync="fenleiVisible"
      width="30%">
      <div class="fenleiFlex">
        <div style="margin:5px;" v-for="(item,index) in classificationList" :key="index">
          <el-tag>{{classificationType==1?item:item.categoryName}}</el-tag>
        </div>
      </div>
    </el-dialog>
    <!-- 选号车 -->
    <shopCart :drawerShow='drawerShow' :shopList="shopList" @deleteValueClick="deleteValueClick" @closeClick="closeClick" @drawerClick="drawerClick"></shopCart>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="approvalDialog"
      width="30%">
      <!-- 启动审批详情,盖章审批详情-->
      <div v-if="notPassReason">{{notPassReason}}</div>
      <div v-else>
        <div v-if="finalApproval.auditStatus == 11 || finalApproval.auditStatus==12">
          <div v-if="finalApproval.staff4NameList" style="padding-top:2px;">
            (四级可审批人：
            <span v-for="(item,index) in finalApproval.staff4NameList" :key="index">
              {{item}},
            </span>)
          </div>
        </div>
        <div v-if="finalApproval.auditStatus == 13 || finalApproval.auditStatus==14">
          <div>四级审批人：{{finalApproval.staff4Name}}</div>
          <div v-if="finalApproval.staff3NameList" style="padding-top:2px;">
            (三级可审批人：
            <span v-for="(item,index) in finalApproval.staff3NameList" :key="index">
              {{item}},
            </span>)
          </div>
        </div>
        <div v-if="finalApproval.auditStatus == 15 || finalApproval.auditStatus==16">
          <div>三级审批人：{{finalApproval.staff3Name}}</div>
          <div v-if="finalApproval.staff2NameList" style="padding-top:2px;">
            (二级可审批人：
            <span v-for="(item,index) in finalApproval.staff2NameList" :key="index">
              {{item}},
            </span>)
          </div>
        </div>
        <div v-if="finalApproval.auditStatus == 17 || finalApproval.auditStatus==18">
          <div>二级审批人：{{finalApproval.staff2Name}}</div>
          <div v-if="finalApproval.qyLeaderNameList" style="padding-top:2px;">
            (签约总监可审批人：
            <span v-for="(item,index) in finalApproval.qyLeaderNameList" :key="index">
              {{item}},
            </span>)
          </div>
        </div>
        <div style="padding:10px 0;">
          审批状态：{{auditStatusList[finalApproval.auditStatus]}}
        </div>
        <div>审批备注：{{finalApproval.auditRemark}}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { bloggerPageList ,bloggerAuditDetail } from "../api";
import util from "@/util/util";
import shopCart from "../../media/component/shopCart"
import { mediaConfig } from "@/const/config/media";
import { mapGetters } from "vuex";
export default {
  components: {
    shopCart
  },
  data() {
    return {
      tableFixed:true,
      fenleiVisible:false,
      drawerShow:false,
      loading:false,
      allTotalFansNum:"",
      allTotalInteractNum:"",
      drawer: false,
      dialogVisible:false,
      total:0,
      OrderName:"",//订单名称
      formInline: {
        bloggerName: "",
        mediaAccountName:"",
        pageNum: 1,
        pageSize: 10,
      },
      tableData:[],
      selectArr: [],
      priceModalTable:[],
      priceModal:false,
      shopList:[],
      disableMediaCheckbox:[],
      classificationList:[],
      classificationType:'',
      approvalDialog:false,
      notPassReason:"",
      finalApproval:{},
      dialogTitle:"" ,
      auditStatusList:['','','','','','','','','','','','待4级审批','4级审批不通过','待3级审批','3级审批不通过','待2级审批','2级审批不通过','待签约总监审批','签约总监审批不通过','审批通过' ],
    };
  },
  watch:{
    drawerShow: {
      handler(newVal, oldVal) {
        console.log('===+AAAAA====',newVal)
        if(newVal){
          this.tableFixed = false
        }else{
          this.tableFixed = true
        }
      },
      deep: true
    }
  },
  methods: {
    //启动审批详情
    async approvalDeatilClick(id,parentId,type){
      console.log("scope.row.parentId=",parentId);
      this.notPassReason = '';
      if(type == 1){
        if(parentId==0){
          this.finalApproval = await this.getAuditDetail(id);
        }else{
          this.finalApproval = await this.getAuditDetail(parentId);    
        }
        this.dialogTitle = '博主审批详情'
        this.approvalDialog = true
      }else{
        this.dialogTitle = '审批不通过原因'
        this.approvalDialog = true;
        this.notPassReason = id;
      }
    },


    async getAuditDetail(id){
      let res = await bloggerAuditDetail({id});
      console.log('=====审批详情=====',res)
      return res.data
    },
    //分类数据
    classificationDetails(data,type){
      this.fenleiVisible = true;
      this.classificationList = data;
      this.classificationType = type;
      console.log('====数据======',data)
    },
    //重制
    resetClick(){
      this.formInline={
        bloggerName: "",
        mediaAccountName:"",
        pageNum: 1,
        pageSize: 10,
      }
      this.onSubmit()
    },
    cellStyle({row, column, rowIndex, columnIndex}){
      if(row.updateUserId){
        return 'background:#FFF;border:0;border-top:1px solid #ebeef5 !important;height:82px;'
      }else{
        return 'border:0;height:127px;'
      }
    },
    toEdit(mediaType, mediaId){
      let mtt_en = mediaConfig.getAppointed("media_en", mediaType);
      let router = this.$router.resolve({
        path: `/media/${mtt_en}/edit`,
        query: {
          mid: mediaId,
        },
      });
      window.open(router.href);
    },
    //清空 取消选择
    deleteValueClick(){
      this.drawerShow = false
      this.shopList = [];
      this.disableMediaCheckbox = [];
      this.$store.state.common.shoppingCartList = []
      this.$refs.product.clearSelection();
      this.initData(this.tableData);
      // console.log('======123======',this.tableData)
    },
    //删除当条 取消选择
    closeClick(item){
      let index = this.shopList.findIndex(
        (v) => v.mediaId == item.mediaId && v.mediaType == item.mediaType
      );
      let tbItem = this.tableData.find(
        (v) => v.mediaId == item.mediaId && v.mediaType == item.mediaType
      );
      if (index !== -1) {
        this.shopList.splice(index, 1);
        // this.$nextTick(function(){
        //   this.$refs.product.toggleRowSelection(tbItem, false);
        // })
        //取消选中
        this.$nextTick(() => {
          this.tableData.forEach((element) => {
            element.mediaAccountList.forEach(item => {
              let selected =
                this.shopList.findIndex(
                  (v) =>
                    v.mediaId == item.mediaId && v.mediaType == item.mediaType
                ) !== -1;
              this.$refs.product.toggleRowSelection(item, selected);
            });
          });
        });
        // 存入数据
        sessionStorage.setItem("shoppingCartList",JSON.stringify(this.shopList))
        this.$forceUpdate();

        // if(this.shopList.length === 0){
        //   this.$refs.product.clearSelection();
        // }
      }
    },
    /**
     * 显示更多价格
     * @param {Array} priceList 价格列表
     */
    onShowMorePrice(priceList) {
      console.log(priceList)
      this.priceModalTable = priceList;
      this.priceModal = true;
    },
    bloggerPageList(){
      this.loading = true;
      bloggerPageList(this.formInline).then(res=>{
        this.tableData = res.data
        this.total = res.total
        this.allTotalFansNum = res.allTotalFansNum
        this.allTotalInteractNum = res.allTotalInteractNum
        //主动赋值 id
        for (let i = 0; i < res.data.length; i++) {
          this.tableData[i].parentId = 0;
          this.tableData[i].mediaId = Math.random().toString(36).substr(2) + i
          if(this.tableData[i].mediaAccountList.length>0){
            for (let k = 0; k < this.tableData[i].mediaAccountList.length; k++) {
              // this.tableData[i].mediaAccountList[k].parentId = 2;
              this.tableData[i].mediaAccountList[k].parentId = this.tableData[i].id;
              this.tableData[i].mediaAccountList[k].status = this.tableData[i].status ;
            }
          }
        }
        this.initData(this.tableData);
        //获取数据
        let data = sessionStorage.shoppingCartList;
        if(data){
          this.$store.state.common.shoppingCartList = JSON.parse(data);
          this.shopList = this.$store.state.common.shoppingCartList;
        }
        this.loading = false;
        // 选中匹配
        this.$nextTick(() => {
          this.tableData.forEach((element) => {
            element.mediaAccountList.forEach(item => {
              let selected =
                this.shopList.findIndex(
                  (v) =>
                    v.mediaId == item.mediaId && v.mediaType == item.mediaType
                ) !== -1;
              this.$refs.product.toggleRowSelection(item, selected);
              // this.setRowIsSelect(element);
            });
          });
        });
      })
    },
    //创建订单
    addOrderClick(){
      this.dialogVisible = true;
    },
    //编辑
    editClick(id){
      console.log('=====ID=====',id);
      let router = this.$router.resolve({
        path: '/blogger/bzList/edit',
        query: {
          id: id
        },
      });
      window.open(router.href);
    },
    //查询
    onSubmit() {
      this.formInline.pageNum = 1;
      this.bloggerPageList()
    },
    handleSizeChange(val) {
      this.formInline.pageSize = val;
      this.bloggerPageList()
    },
    handleCurrentChange(val) {
      this.formInline.pageNum = val;
      this.bloggerPageList()
    },

    

    

    goUrl(id){
      let router = this.$router.push({
        path: "/blogger/bzList/edit",
        query: {
          id,
        },
      });
      window.open(router.href, "_blank");
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },

    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
    //初始化数据
    initData(data) {
      data.forEach((item) => {
        item.isSelect = false; //默认为不选中
        if (item.mediaAccountList && item.mediaAccountList.length) {
          this.initData(item.mediaAccountList);
        }
      });
    },
    drawerClick(){
      this.tableFixed = true;
    },
    selectFun(selection, row) {
      if (row.mediaAccountList) {
        this.setRowIsSelect(row);
        if(row.mediaAccountList.length<=0)return
        let other = [] //其他页数据
        if (row.isSelect) { 
          row.mediaAccountList.forEach((v) => {
            if (
              row.mediaAccountList.findIndex(
                (v1) => v1.mediaType == v.mediaType && v1.mediaId == v.mediaId
              ) === -1
            ) {
              other.push(v);
            } else {
              let index =  this.shopList.findIndex(
                (v) => v.mediaId == row.mediaId && v.mediaType == row.mediaType
              );
              if (index === -1) {
                this.shopList.push(v);
              } else {
                this.$store.state.common.shoppingCartList.splice(index, 1);
              }
            }
          });
        }else{  
          console.log(22222)
          row.mediaAccountList.forEach(item => {
            //清理抽重复数据
            let index =  this.$store.state.common.shoppingCartList.findIndex(
              (v) => v.mediaId == item.mediaId && v.mediaType == item.mediaType
            );
            this.$store.state.common.shoppingCartList.splice(index, 1);
          });
        }
        this.$store.state.common.shoppingCartList =  this.shopList;
      }else{
        //单选数据
        let index = this.$store.state.common.shoppingCartList.findIndex(
          (v) => v.mediaId == row.mediaId && v.mediaType == row.mediaType
        );
        if (index === -1) {
          this.$store.state.common.shoppingCartList.unshift(row)
        } else {
          this.$store.state.common.shoppingCartList.splice(index, 1);
        }
        this.setRowIsSelect(row);
      }
      //去重
      let arr = this.$store.state.common.shoppingCartList;
      let obj = {}; 
      arr.forEach((item)=> obj[item.mediaId]=item); 
      let a = []; 
      for ( let key in obj) { a.push(obj[key])};  
      this.$store.state.common.shoppingCartList = this.shopList = a;

      sessionStorage.setItem("shoppingCartList",JSON.stringify(this.$store.state.common.shoppingCartList))
      this.drawerShow = true
    },
    setRowIsSelect(row) {
      //当点击父级点复选框时，当前的状态可能为未知状态，所以当前行状态设为false并选中，即可实现子级点全选效果
      if (row.isSelect === "") {
        row.isSelect = false;
        this.$refs.product.toggleRowSelection(row, true);
      }
      row.isSelect = !row.isSelect;
      let that = this;

      function selectAllChildrens(data) {
        data.forEach((item) => {
          item.isSelect = row.isSelect;
          that.$refs.product.toggleRowSelection(item, row.isSelect);
          if (item.mediaAccountList && item.mediaAccountList.length) {
            selectAllChildrens(item.mediaAccountList);
          }
        });
      }

      function getSelectStatus(selectStatuaArr, data) {
        data.forEach((mediaAccountListItem) => {
          selectStatuaArr.push(mediaAccountListItem.isSelect);
          if (
            mediaAccountListItem.mediaAccountList &&
            mediaAccountListItem.mediaAccountList.length
          ) {
            getSelectStatus(
              selectStatuaArr,
              mediaAccountListItem.mediaAccountList
            );
          }
        });
        return selectStatuaArr;
      }
      function getLevelStatus(row) {
        //如果当前节点的parantId =0 并且有子节点，则为1
        //如果当前节点的parantId !=0 并且子节点没有子节点 则为3
        if (row.parentId == 0) {
          if (row.mediaAccountList && row.mediaAccountList.length) {
            return 1;
          } else {
            return 4;
          }
        } else {
          if (!row.mediaAccountList || !row.mediaAccountList.length) {
            return 3;
          } else {
            return 2;
          }
        }
      }
      let result = {};
      //获取明确的节点
      function getExplicitNode(data, parentId) {
        data.forEach((item) => {
          if (item.id == parentId) {
            result = item;
          }
          if (item.mediaAccountList && item.mediaAccountList.length) {
            getExplicitNode(item.mediaAccountList, parentId);
          }
        });
        return result;
      }
      function operateLastLeve(row) {
        //操作的是子节点  1、获取父节点  2、判断子节点选中个数，如果全部选中则父节点设为选中状态，如果都不选中，则为不选中状态，如果部分选择，则设为不明确状态
        let selectStatuaArr = [];
        let item = getExplicitNode(that.tableData, row.parentId);
        selectStatuaArr = getSelectStatus(
          selectStatuaArr,
          item.mediaAccountList
        );
        if (
          selectStatuaArr.every((selectItem) => {
            return true == selectItem;
          })
        ) {
          item.isSelect = true;
          that.$refs.product.toggleRowSelection(item, true);
        } else if (
          selectStatuaArr.every((selectItem) => {
            return false == selectItem;
          })
        ) {
          item.isSelect = false;
          that.$refs.product.toggleRowSelection(item, false);
        } else {
          item.isSelect = "";
        }
        //则还有父级
        if (item.parentId != 0) {
          operateLastLeve(item);
        }
      }
      //判断操作的是子级点复选框还是父级点复选框，如果是父级点，则控制子级点的全选和不全选
      //1、只是父级 2、既是子集，又是父级 3、只是子级
      let levelSataus = getLevelStatus(row);
      if (levelSataus == 1) {
        selectAllChildrens(row.mediaAccountList);
      } else if (levelSataus == 2) {
        selectAllChildrens(row.mediaAccountList);
        operateLastLeve(row);
      } else if (levelSataus == 3) {
        operateLastLeve(row);
      }
    },
    selectAllFun(selection) {
      let isAllSelect = this.checkIsAllSelect();
      this.tableData.forEach((item) => {
        item.isSelect = isAllSelect;
        this.$refs.product.toggleRowSelection(item, !isAllSelect);
        this.selectFun(selection, item);
      });
    },
    rowClassNameFun({ row }) {
      if (row.isSelect === "") {
        return "indeterminate";
      }
    },
    headerRowClassName({ row }) {
      let oneProductIsSelect = [];
      this.tableData.forEach((item) => {
        oneProductIsSelect.push(item.isSelect);
      });
      if (oneProductIsSelect.includes("")) {
        return "indeterminate";
      }
      return "";
    },
    checkIsAllSelect() {
      this.oneProductIsSelect = [];
      this.tableData.forEach((item) => {
        this.oneProductIsSelect.push(item.isSelect);
      });
      //判断一级产品是否是全选.如果一级产品全为true，则设置为取消全选，否则全选
      let isAllSelect = this.oneProductIsSelect.every((selectStatusItem) => {
        return true == selectStatusItem;
      });
      return isAllSelect;
    },
  },
  computed: {},
  mounted() {
    this.bloggerPageList();
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
};
</script>
<style>
.el-table__expand-icon{
  z-index: 99999;
}
</style>
<style lang="scss" scoped>
.fenleiFlex{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.el-table /deep/.el-icon-arrow-right:before {
  background: url('../assets/img/triangleA.png') no-repeat 0 3px;
  content: '';
  display: block;
  width: 30px;
  height: 30px;
  background-size: 18px;
}

/* 博主名称样式修改 */
// /deep/.el-table_1_column_2{
//   .cell{
//     display: flex !important;
//     align-items: center !important;
//   }
// }

/deep/.el-table__indent{
  padding-left: 0 !important;
}
.overflow-content-wrap{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.media-price-wrap li{
  font-size: 14px;
}
.disbox_flx{
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
//分类项
  .category-item {
    display: inline-block;
    margin: 3px;
    font-size: 12px;
  }
  .category_disp{
    // display: flex;
    // -webkit-flex-wrap: wrap;
    // align-items: center;
    // justify-content: center;
  }
  //更多价格
  .more-price {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    cursor: pointer;
    .iconfont {
      margin-right: 5px;
      font-weight: bold;
    }
  }
.typeImgWx{
  display: inline-block;
  width: 50px;
  height: 30px;
  margin-top: 5px;
  background: url('/img/media-type.png') no-repeat top center/100% auto;
}
.typeImgTb{
  display: inline-block;
  width: 50px;
  height: 30px;
  margin-top: 5px;
  background: url('/img/media-type.png') no-repeat top center/100% auto;
  background-position: 0 -182px;
}
.typeImgDy{
  display: inline-block;
  width: 50px;
  height: 30px;
  margin-top: 5px;
  background: url('/img/media-type.png') no-repeat top center/100% auto;
  background-position: 0 -92px;
}

// 购物车
.cart_box{
  position: fixed;
  right: 0;
  top: 260px;
  margin-bottom: 10px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-size: 24px;
  text-align: center;
  background: #1e1e1e;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  cursor: pointer;
  color: #FFF;
  z-index: 99;
}


.main-container {
  margin: 20px;
}

// 抽屉样式处理
.drawerIndex{
  z-index: 0 !important;
}
.el-table::before{
  z-index: 0 !important;
}

//处理博主名称  ---影响其他
// /deep/.el-table .cell{
//   display: flex;
//   align-items: center;
// }

//列表“博主名称”特殊处理
/deep/ .el-table th:nth-child(2) div{
  display: inline-block !important;
  text-align: center;
}
//列表“博主名称”特殊处理
/deep/.el-table__row td:nth-child(2) .cell{
  display: flex;
  align-items: center;
}

/deep/ .el-table th:nth-child(1) div{
  display: inline-block !important;
  text-align: center;
}
//列表“博主名称”特殊处理
/deep/.el-table__row td:nth-child(1) .cell{
  display: flex;
  align-items: center;
}


.account-wrap {
    display: flex;
    cursor: pointer;
    //头像
    .avatar-out {
      /*width: 50%;*/
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .avatar-in {
        position: relative;
        width: 42px;
        height: 42px;
        margin-right: 10px;
        float: right;
        .img-wrap {
          position: relative;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            &.is-code {
              position: absolute;
              top: -84px;
              left: -84px;
              width: 210px;
              height: 210px;
            }
          }
        }
      }
    }
    //基础信息
    .info-wrap {
      display: flex;
      align-items: center;
      width: 80%;
      font-size: 12px;
      text-align: left;
      .nickname {
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }


  /deep/.el-drawer__header{
    font-size: 20px;
    font-weight: 500;
  }
  //隐藏滚动条
  .el-scrollbar__thumb {
    display: none;
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
    overflow-y: auto;
  }
  // 抽屉
  .drawer_hei{
    overflow: auto;
    height: 100%;
    padding-bottom: 240px;
  }
  .drawer_head{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #999;
    padding:15px;
    padding-top: 0;
    font-size: 15px;
    position: relative;

  }
  .drawer_fixed_box{
    position: absolute;
    bottom:0;
    width: 100%;
    height: 60px;
    color: #FFF;
    line-height: 60px;
    font-size: 15px;
    text-align: center;
    z-index: 10;
    background: #d9001b;
  }
  .drawer_fixed_text{
    height: 40px;
    position: absolute;
    bottom: 60px;
    background: #fff;
    line-height: 40px;
    width: 100%;
    padding-left:15px;
    font-size: 14px;
  }
  .drawer_list{
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #EFEFEF;
    padding:0 15px;
  }
  .list_left,.cli_val{
    display: flex;
    align-items: center;
  }
  .cli_val{
    margin-left:10px;
  }
  .headerImg{
    width: 100%;
    height: 100%;
    border-radius: 100px;
  }
</style>
<style lang='scss' >
.indeterminate .el-checkbox__input .el-checkbox__inner {
  background-color: #409eff !important;
  border-color: #409eff !important;
  color: #fff !important;
}

.indeterminate .el-checkbox__input.is-checked .el-checkbox__inner::after {
  transform: scale(0.5);
}

.indeterminate .el-checkbox__input .el-checkbox__inner {
  background-color: #f2f6fc;
  border-color: #dcdfe6;
}
.indeterminate .el-checkbox__input .el-checkbox__inner::after {
  border-color: #c0c4cc !important;
  background-color: #c0c4cc;
}
.product-show th .el-checkbox__inner {
  display: none !important;
}

.indeterminate .el-checkbox__input .el-checkbox__inner::after {
  content: "";
  position: absolute;
  display: block;
  background-color: #fff;
  height: 2px;
  transform: scale(0.5);
  left: 0;
  right: 0;
  top: 5px;
  width: auto !important;
}
.product-show .el-checkbox__inner {
  display: block !important;
}

.product-show .el-checkbox {
  display: block !important;
}
.sandian{
  margin-top:4px;
  margin-left: -3px;
}
</style>